module.exports = __webpack_public_path__ + "img/h5img3.6cd871cc.png";